let dataObject = {
    "type": "FeatureCollection",
    "features": []
}
var coords = []

let $path = $('.data-path').attr('data-attr')

function onSchedule(outlet) {

    if(outlet.schedule.length === 0 || !outlet.schedule ) {
        return {
            'start': '8-00',
            'end': '17-00',
            'breakStart': '12-00',
            'breakEnd': '13-00',
        }
    }

    if(outlet.schedule.length !== 0) {
        return {
            'start': outlet.schedule[0].WorkStart,
            'end': outlet.schedule[0].WorkEnd,
            'breakStart': outlet.schedule[0].BreakStart,
            'breakEnd': outlet.schedule[0].BreakEnd,
        }
    }
}
outlets.forEach((outlet, index) => {
        let schedule = onSchedule(outlet)
        dataObject.features.push(
            {
                "type": "Feature",
                "id": index,
                "geometry": {
                    "type": "Point",
                    "coordinates": outlet.coords
                },
                "properties": {
                    "balloonContentHeader": `<div class='balloon__header'><b>Время работы:</b> пн-пт: с ${schedule.start} до ${schedule.end}, сб-вс: выходной </div>`,
                    "balloonContentBody": `<div class='balloon__body'><b>Ориентир:</b> ${outlet.description === '' ? '-' : outlet.description}</div>`,
                    "balloonContentFooter": `<div class='balloon__footer'><b>Город</b>: ${outlet.city}</div>
                                             <div class='balloon__footer'><b>Адрес</b>: ${outlet.address}</div>       `,
                }
            }
        )
    }
)

const mapOptions = {
    iconLayout: 'default#imageWithContent',
    iconImageHref: `${$path}/images/map-pvz-pin.svg`,
    iconImageSize: [48, 48],
    iconImageOffset: [-24, -24],
    hideIconOnBalloonOpen: false,
    balloonOffset: [ 0, -20 ]
}

const objectManagerOptions = {
    clusterize: false,
    gridSize: 32,
    clusterDisableClickZoom: true
}
$('.local-outlets').on('click', '.local-map', function () {
    let wrapperId = $(this).closest('li').attr('id')
    let city = $(`li[id=${wrapperId}] .city-name`).text();
    let address = $(`li[id=${wrapperId}] .outlet-address`).text();
    coords = outlets.filter(v => v.city === city && v.address === address)[0].coords

    ymaps.ready(init);
    function init () {
        var myMap = new ymaps.Map(`YMapsID ${wrapperId}`, {
                center: coords,
                zoom: 15
            }),
            objectManager = new ymaps.ObjectManager(objectManagerOptions);
        objectManager.objects.options.set(mapOptions);
        objectManager.add(dataObject)
        myMap.geoObjects.add(objectManager);

        $('#map-close').click(function () {
            myMap.destroy()
        })
    }
})
$('.searched-outlets').on('click', '.local-map', function () {
    let wrapperId = $(this).closest('li.desired').attr('id')
    let city = $(`li[id="${wrapperId}"].desired`).find('.city-name').text();
    let address = $(`li[id="${wrapperId}"] .outlet-address`).text();
    coords = outlets.filter(v => v.city === city && v.address === address)[0].coords

    ymaps.ready(init);
    function init () {
        var myMap = new ymaps.Map(`YMapsID Search ${wrapperId}`, {
                center: coords,
                zoom: 15
            }),
            objectManager = new ymaps.ObjectManager(objectManagerOptions);
        objectManager.objects.options.set(mapOptions);
        objectManager.add(dataObject)
        myMap.geoObjects.add(objectManager)

        $('.btn-close').click(function () {
            myMap.destroy()
        })
    }
})

$('.global').on('click', function () {
    $('button[data-map="exec"]').attr('id', '')
    ymaps.ready(init);

    function init () {
        var myMap = new ymaps.Map('YMapsID', {
                center: [82.977509, 55.036633],
                zoom: 4
            }),
            objectManager = new ymaps.ObjectManager(objectManagerOptions);
        objectManager.objects.options.set(mapOptions);
        objectManager.add(dataObject)
        myMap.geoObjects.add(objectManager);

        $('#global-map-close').click(function () {
            myMap.destroy()
        })
    }
})
